<style scoped>
.bg-primary {
  background-color: #1a3665 !important;
}
.file {
  visibility: hidden;
  position: absolute;
}
.browse {
  background-color: #1a3665 !important;
  color: white;
}
.custom-file-input ~ .custom-file-label[data-browse]::after {
  background-color: #1a3665 !important;
  color: white !important;
  word-wrap: break-word !important;
  white-space: normal !important;
}
.upload-btn-wrapper {
  width:100%;
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.btn-upload {
  width:50%;

  border: 2px solid gray;
  color: gray;
  background-color: white;
  padding: 5px 15px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: bold;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 30px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
</style>
<template>
  <CCard>
    <CCardHeader
      style="background: #1a3665; color: white"
      class="d-flex align-items-center font-weight-bold"
    >
      Master Artikel
      <template v-if="role_status && role_status.status_create">
      <CButton
        color="success"
        style="float: right"
        class="btn-md ml-auto button-md-block px-3"
        @click="$router.push('/data-master/artikel/tambah')"
        >Tambah</CButton
      >
      </template>
      <template v-else>
        <CButton
          color="secondary"
          style="float: right"
          class="btn-md ml-auto button-md-block px-3"
          disabled
          >Tambah</CButton
        >
      </template>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol xl="12">
          <CSelect
            label="Data Perhalaman"
            class="float-left"
            @change="changePageSize"
            :options="[10, 25, 100, 'Semua Data']"
          />
          <CInput
            label="Pencarian"
            class="float-right"
            placeholder="Cari Data .."
            v-model="search"
          />
          <br />
        </CCol>

        <CCol lg="12" class="table-responsive">
          <CDataTable
            style="widht: 100% !important"
            :items="items"
            :fields="fields"
            hover
            sorter
          >
            <template #no="{ index }">
              <td class="py-2">{{ index + 1 }}</td>
            </template>
            <template #judul="{ item }">
              <td class="py-2">{{ item.judul.substr(0, 40) + "..."  }}</td>
            </template>
            <template #isi="{ item }">
              <td class="py-2">{{ item.isi.substr(0, 60) + "..." }}</td>
            </template>

            <template #flyer="{ item }">
              <td class="py-2">
                  <img
                    :src=" baseUrl+
                    '/files?filename=' + item.flyer +
                    '&path=datamaster@artikel'"
                    style="height:80px; width:80px"
                    class=" img img-responsive elevation-2 border"
                    alt="User Picture"
                  /> 
                </td>
            </template>

            <template #aksi="{ item, index }">
              <td class="py-2 text-center">
                  <template v-if="role_status && role_status.status_update">
                  <CButton
                    v-c-tooltip="'Ubah'"
                    color="info"
                    square
                    class="btn-sm"
                    @click="$router.push('/data-master/artikel/edit/'+item.idArtikel)"
                  >
                    <font-awesome-icon icon="edit" /> </CButton
                  >&nbsp;&nbsp;
                  </template>
                  <template v-else>
                  <CButton
                    v-c-tooltip="'Ubah'"
                    color="secondary"
                    square
                    class="btn-sm"
                    disabled
                  >
                    <font-awesome-icon icon="edit" /> </CButton
                  >&nbsp;&nbsp;
                  </template>
                  <template v-if="role_status && role_status.status_delete">
                  <CButton
                      v-c-tooltip="'Hapus'"
                      color="danger"
                      square
                      class="btn-sm"
                      @click="deleteData(item, index)"
                    >
                      <font-awesome-icon icon="trash" />
                  </CButton>
                  </template>
                  <template v-else>
                  <CButton
                      v-c-tooltip="'Hapus'"
                      color="secondary"
                      square
                      class="btn-sm"
                      disabled
                    >
                      <font-awesome-icon icon="trash" />
                  </CButton>
                  </template>
              </td>
            </template>
          </CDataTable>

          <CPagination
            style="float: right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>
    </CCardBody>
  </CCard>
</template>
<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import { UploadImage } from '@/mixins/UploadImage'
import ArtikelService from "@/services/datamaster/artikel.service";
import BaseUrl from "@/services/base-url";
import { AlertUtils } from "@/mixins/AlertUtils";
import { Pagination } from "@/mixins/Pagination";
import { exportUtils } from "@/mixins/exportUtils";

const fields = [
  { key: "no" },
  { key: "flyer", _style: "width:20%; text-align: center" },
  { key: "judul", _style: "text-align: left" },
  { key: "isi", label: "Konten", _style: "width:40%; text-align: left" },
  { key: "aksi", _style: "width:16%; text-align: center" },
];

export default {
  name: "Artikel",
  mixins: [AlertUtils, exportUtils, UploadImage, Pagination],
  data() {
    return {
      formData: {
        no: "",
        judul: "",
        isi: "",
        id: "",
        idArtikel: "",
        flyer: null,
        statusUpdateFile: "",
        status: "",
      },
      lihat_foto: null,
      fields,
      items: [],
      pagination: {
        totalPages: 0
      },
      role_status: null
    };
  },

  mounted() {
    this.roleData();
    this.baseUrl = BaseUrl();
    this.getData("0", this.pageSize, "default");    
  },
  methods: {
    pageChange() {
      this.getData(this.currentPage, this.pageSize, this.search);
    },

    getData(currentPage, pageSize, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      ArtikelService.getArtikel(currentPage, pageSize, filter)
        .then((response) => {
          loader.hide();
          this.items = response.data.data.content;
          this.pagination.totalPages = response.data.data.totalPages;
          this.currentPage = response.data.data.pageable.pageNumber + 1;
          setTimeout(() => loader.hide(), 1000);
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    deleteData(item, index) {
      this.formData = item;
      var vm = this;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            ArtikelService.deleteArtikel(this.formData)
              .then((response) => {
                vm.alertDeleteSuccess();
                this.getData("0", this.pageSize, "default");
              })
              .catch((error) => {
                this.alertError();
                vm.getData("0");

                // comment console console.log(error);
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },
    roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
      this.role_status = data;
    }
  },
};
</script>